'use client';

import { useTranslations } from 'next-intl';

import CheckAuditIcon from '@/assets/icons/check-audit.svg';
import WinIcon from '@/assets/icons/winIcon.svg';
import { Typography } from '@/components/shared/Typography';

function AuditChecked() {
  const t = useTranslations('footer');

  return (
    <a href="/audit.pdf" target="_blank" rel="noopener noreferrer">
      <div className=" bg-secondary border w-full flex items-center justify-between gap-3 py-3 rounded-full px-4 pulsate-glow">
        <CheckAuditIcon className="w-5 h-5" />
        <Typography
          as="h4"
          variant="p"
          className="font-bold text-secondary-foreground text-center"
        >
          {t('smartContractsAudited')}
        </Typography>
        <WinIcon className="h-5" />
      </div>
    </a>
  );
}

export default AuditChecked;
